<template>
  <div>
    <v-app-bar :app="isApp" clipped-right dense dark v-if="isCustomTopNav" :color="topBarColorString">
      <v-btn
        icon
        v-if="$vuetify.breakpoint.mdAndDown"
        @click="drawer = !drawer"
        ><v-icon size="32">mdi-menu</v-icon></v-btn>

      <slot name="app-bar-title"><bread-crumb /></slot>
      
      <slot name="app-bar-main">
        <v-spacer />
        
        <working-indicator />

        <global-search />
      </slot>
      
      <div v-if="userSettingsEnabled">
        <dialog-card title="Settings" :fullscreen="true" :ok="null" v-model="settingsDialog">

          <v-btn icon small slot="activator">
            <v-icon size="16">mdi-account</v-icon>
          </v-btn>

      
          <settings-page />

          <v-toolbar slot="actions" dense flat>
            <v-spacer />
            <v-btn @click="settingsDialog = false" color="primary">Done</v-btn>
          </v-toolbar>

        </dialog-card>
      </div>

      <slot name="app-bar-settings">
        <ui-app-settings />
      </slot>
      
    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      :app="isApp"
      clipped left hide-overlay
      :mini-variant="mini && $vuetify.breakpoint.lgAndUp"
      :permanent="$vuetify.breakpoint.lgAndUp"
      @input="drawer = $event"
      class="nav-drawer"
      :style="navStyle"
      :dark="globalDarkMode" :light="!globalDarkMode"
    >
      <v-toolbar dense dark :color="topBarColorString"
      >
        <div v-if="!mini">
          <v-avatar color="primary" small>
            <v-icon dark large v-show="!userProfilePic">mdi-account</v-icon>
            <img
              :src="userProfilePic"
              v-show="userProfilePic"
            />
          </v-avatar>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on" style="padding-left: 5px;">{{ userName }}</span>
            </template>
            <span>{{userNameFull}}</span>
          </v-tooltip>
          
        </div>
        <v-spacer v-if="!mini"></v-spacer>
        <v-btn icon @click.stop="mini = !mini" v-if="!$vuetify.breakpoint.mdAndDown">
            <v-icon>{{ mini ? "mdi-chevron-double-right" : "mdi-chevron-double-left"}}</v-icon>
        </v-btn>                  
      </v-toolbar>
      <v-divider></v-divider>
      <div>
        <v-card color="transparent" tile flat>
          <slot name="leftNavItems">
            <v-list nav dense>
              
              <v-list-item link v-if="isShowMainMenuLink" to="/" style="">
                <v-list-item-icon>
                  <v-tooltip right v-if="mini">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">mdi-chevron-left</v-icon>
                    </template>
                    <span>Main Menu</span>
                  </v-tooltip>
                  <div v-if="!mini">
                    <v-icon>mdi-chevron-left</v-icon>
                  </div> 
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Main Menu</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              
              <v-divider></v-divider>

              <div v-for="(groupItem, j) in menuItems" :key="j">
                <div v-if="groupItem.items">
                  <v-list-group :value="groupItem.value" @click="handleExpandCollapse(groupItem.text)">
                    <template v-slot:activator>
                      <v-tooltip right :disabled="!mini && groupItem.text.length < 25">
                        <template v-slot:activator="{ on, attrs }">
                          <v-list-item-action v-bind="attrs" v-on="on">
                              <v-icon>{{ groupItem.icon }}</v-icon>
                          </v-list-item-action>                          
                          <v-list-item-content>
                            <v-list-item-title v-text="groupItem.text"></v-list-item-title>
                          </v-list-item-content>
                        </template>
                        <span>{{groupItem.text}}</span>
                      </v-tooltip>
                    </template>
                    <v-list nav dense>
                      <div v-for="(item, i) in groupItem.items" :key="i">
                        <!-- Router Links -->
                        <v-tooltip right :disabled="!mini && item.text.length < 25">
                          <template v-slot:activator="{ on, attrs }">
                            <v-list-item
                              link
                              :to="item.link.indexOf('http') === -1 ? item.link : ''"
                              :href="item.link.indexOf('http') !== -1 ? item.link : ''"
                              :target="item.newWindow ? '_blank' : '_self'"
                              :style="mini ? `padding-left: 0;` : ``"
                              v-bind="attrs" v-on="on"
                            >
                              <v-list-item-action>
                                <v-icon >{{ item.icon }}</v-icon>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>{{ item.text }}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                          <span>{{item.text}}</span>
                        </v-tooltip>
                      </div>
                    </v-list>
                  </v-list-group>
                </div>
                <div v-else>
                  <v-tooltip right :disabled="!mini && groupItem.text.length < 25">
                    <template v-slot:activator="{ on, attrs }">
                      <v-list-item :to="groupItem.link" link v-on="on" v-bind="attrs">
                        <v-list-item-action>
                          <v-icon  >{{ groupItem.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>{{ groupItem.text }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <span>{{groupItem.text}}</span>
                  </v-tooltip>
                </div>
              </div>
            </v-list>
          </slot>
        </v-card>
      </div>
    </v-navigation-drawer>
    
    <slot>
      Main Body
    </slot>

      <slot name="footer">
        <v-footer absolute dark full-width :color="topBarColorString">
          <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
          <v-chip
            small
            label
            color="green darken-1"
            absolute
            :style="{ right: '5px', position: 'absolute' }"
            >v.<b>{{ version }} </b></v-chip
          >
        </v-footer>
      </slot>
    <!-- <slot name="footer">
      <v-footer absolute dark full-width :color="topBarColorString">
        <span class="white--text">&copy; {{ new Date().getFullYear() }}</span>
        <v-chip
          small
          label
          color="green darken-1"
          absolute
          :style="{ right: '5px', position: 'absolute' }"
          >v.<b>{{ version }}</b></v-chip
        >
      </v-footer>
    </slot> -->
  </div>
</template>

<script>
import recentAlert from "@/_components/layouts/alert-recent";
import uiHeader from "@/_components/layouts/ui-header";
import navMain from "@/_components/layouts/nav-main";
import breadCrumb from "@/_components/layouts/bread-crumb";
import globalSearch from "@/_components/layouts/global-search";
import uiAppSettings from "@/_components/layouts/ui-app-settings";
import logo from "@/_components/layouts/logo";
import workingIndicator from "@/_components/layouts/working-indicator";
import appSettings from "@/_mixins/app-settings-mixin";
import userSettings from "@/_mixins/user-settings-mixin";
import dialogCard from "@/_components/shared/dialog-card"
import settingsPage from "@/_views/my/Settings"


export default {
  name: "PageLayoutSideNav",
  props : {
      version : {type:String, default: "0.0.1"},
      user : {type:Object, default: null},
      isShowMainMenuLink: {type:Boolean, default: true},
      isCustomTopNav: {type:Boolean, default: false},
      navItems: {type:Array, default: []},
      userSettingsEnabled: {type:Boolean, default: true},
      isApp: {type:Boolean, default: true},
    },
  mixins: [userSettings, appSettings],
  components: {
    recentAlert,
    uiHeader,
    navMain,
    breadCrumb,
    globalSearch,
    logo,
    uiAppSettings,
    workingIndicator,
    dialogCard,
    settingsPage
  },
  computed: {
    menuItems: {
      get(){
        if(this.navItems.length > 0){
          if(this.navItemsExpanded?.length > 0){
            var $this = this;
            this.navItems.map(x => x.value = $this.navItemsExpanded.indexOf(x.text) !== -1 ? true : false);
          }
          return this.navItems;
        }
        return this.items;
      },
      set(val){
        //save to the store
      }
    },
    navItemsExpanded() {
        return this.globalNavItemsExpanded && this.globalNavItemsExpanded.length > 0 ? this.globalNavItemsExpanded.split(',') : [];
    },    
    userProfilePic(){
      return !!this.user && this.user.profilePic ? this.user.profilePic : null;
    },
    navStyle() {
        var ret = {};
        if (this.$vuetify.breakpoint.lgAndUp) {
            var color = this.globalNavBackgroundColor
            //console.log(color);
            ret["background-color"] = `rgba(${color.r},${color.g},${color.b},${color.a})`;
        }
        return ret;
    },
    userName(){
      return this.userNameFull.length > 15 ? `${this.userNameFull.substring(0, 15)}...` : this.userNameFull;
    },
    userNameFull(){
      return this.user ? this.user.userName : "";
    }
  },
  mounted() {
    this.mini = !this.globalNavPinnedOpen;
  },
  watch: {
    mini(newValue) {
      this.globalNavPinnedOpen = !newValue;
    },
    globalIsShowLeftNav(){
      this.drawer = true;
    },
    navItems: {
      deep: true,
      handler(newVal){
        var test = newVal;
      }
    }
  },
  data: () => ({
    isPageLoading: true,
    drawer: true,
    mini: false,
    settingsDialog : false,
    items: [
        {
            icon: "mdi-home",
            text: "Home",
            link: "/my-app",
        },
    ],    
  }),
  methods: {
    init() {
    },
    handleExpandCollapse(itemText){
      var idx = this.globalNavItemsExpanded.indexOf(itemText);
      if(idx === -1) this.globalNavItemsExpanded = `${this.globalNavItemsExpanded}${itemText},`;
      else this.globalNavItemsExpanded = this.globalNavItemsExpanded.replace(`${itemText},`, '');
    }
  },
};
</script>

<style lang="scss">
.nav-drawer {
    top: 0px !important;
    height: 100vh !important;
    max-height: 100vh !important;
}
.child-nodes {
    padding: 0px 0px;
    background-color: rgba(0, 0, 0, .25);
}
.router-link,
.router-link * {
    color: white;
    font-family: "Roboto Condensed";
    transition: all .1s ease;
}
.router-link-active {
    font-size: 1.1em;
    font-weight: bold;
    opacity: 1;

}
.router-link {
    margin-left: 0px;
    opacity: .8;

    i {
        visibility: hidden;
    }

}
.router-link.router-link-active {
    opacity: 1;

    i {
        visibility: visible;
    }
}
</style>
